<template>
  <div class="keywords">
    <h1>Taksonomi</h1>
    <b-tabs content-class="mt-3">
      <b-tab title="Trævisning" :active="activeTab === 'treeview'" @click="activeTab = 'treeview'">
        <b-row>
          <b-col>
            <b-overlay :show="loading"  variant="dark" :opacity="0.15" spinner-variant="primary" style="min-height:300px;">
              <treeview :taxonomy="sortedTaxonomy"></treeview>
            </b-overlay>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="Redigering" :active="activeTab === 'edit'" @click="activeTab = 'edit'">
        <b-row>
          <b-col cols="3">
            <h2 class="h5">1. niveau</h2>
            <b-input-group class="mb-3">
              <b-form-input :disabled="keywordOneSaving" placeholder="Tilføj taksonomibegreb" v-model="keywordOneInput" @keyup.enter="addKeywordOne()"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="keywordOneSaving" variant="success" @click="addKeywordOne()"><b-icon icon="check2"></b-icon></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col cols="3">
            <h2 class="h5">2. niveau</h2>
            <b-form>
              <b-input-group class="mb-3">
                <b-form-input placeholder="Tilføj taksonomibegreb" :disabled="!selectedKeywordOne || keywordTwoSaving" v-model="keywordTwoInput" @keyup.enter="addKeywordTwo()"></b-form-input>
                <b-input-group-append>
                  <b-button variant="success" :disabled="!selectedKeywordOne || keywordTwoSaving" @click="addKeywordTwo()"><b-icon icon="check2"></b-icon></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form>
          </b-col>
          <b-col cols="3">
            <h2 class="h5">3. niveau</h2>
            <b-input-group class="mb-3">
              <b-form-input placeholder="Tilføj taksonomibegreb" :disabled="!selectedKeywordTwo || keywordThreeSaving" v-model="keywordThreeInput" @keyup.enter="addKeywordThree()"></b-form-input>
              <b-input-group-append>
                <b-button variant="success" :disabled="!selectedKeywordTwo || keywordThreeSaving" @click="addKeywordThree()"><b-icon icon="check2"></b-icon></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col cols="3">
            <h2 class="h5">4. niveau</h2>
            <b-input-group class="mb-3">
              <b-form-input placeholder="Tilføj taksonomibegreb" :disabled="!selectedKeywordThree || keywordFourSaving" v-model="keywordFourInput" @keyup.enter="addKeywordFour()"></b-form-input>
              <b-input-group-append>
                <b-button variant="success" :disabled="!selectedKeywordThree || keywordFourSaving" @click="addKeywordFour()"><b-icon icon="check2"></b-icon></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3">
            <b-list-group>
              <template v-for="(keyword, index) of sortedTaxonomy">
                <b-overlay
                  :show="loadingItemId === keyword.id"
                  :key="'keyword-one-spinner' + index"
                  variant="light"
                  :opacity="0.5"
                  spinner-variant="primary"
                >
                  <taxonomy-list-item
                    :key="'keyword-' + index"
                    :keyword="keyword"
                    :selectedKeyword="selectedKeywordOne"
                    :editing="editingOne"
                    @set="setKeywordOne($event)"
                    @startEditing="startEditing($event, 1)"
                    @save="saveKeyword(keyword, $event, 1)"
                    @deactivate="deactivateKeyword($event)"
                    @reactivate="reactivateKeyword($event)"
                    @delete="deleteKeyword($event, 1)"
                  ></taxonomy-list-item>
                </b-overlay>
              </template>
            </b-list-group>
          </b-col>
          <b-col cols="3">
            <div v-if="keywordsTwo.length === 0" class="bg-light h-100 rounded"></div>
            <b-list-group>
              <template v-for="(keyword, index) of keywordsTwo">
                <b-overlay
                  :show="loadingItemId === keyword.id"
                  :key="'keyword-two-spinner' + index"
                  variant="light"
                  :opacity="0.5"
                  spinner-variant="primary"
                >
                  <taxonomy-list-item
                    :key="'keyword-two-' + index"
                    :keyword="keyword"
                    :selectedKeyword="selectedKeywordTwo"
                    :editing="editingTwo"
                    @set="setKeywordTwo($event)"
                    @startEditing="startEditing($event, 2)"
                    @save="saveKeyword(keyword, $event, 2)"
                    @deactivate="deactivateKeyword($event)"
                    @reactivate="reactivateKeyword($event)"
                    @delete="deleteKeyword($event ,2)"
                  ></taxonomy-list-item>
                </b-overlay>
              </template>
            </b-list-group>
          </b-col>
          <b-col cols="3">
            <div v-if="keywordsThree.length === 0" class="bg-light h-100 rounded"></div>
            <b-list-group>
              <template v-for="(keyword, index) of keywordsThree">
                <b-overlay
                  :show="loadingItemId === keyword.id"
                  :key="'keyword-three-spinner' + index"
                  variant="light"
                  :opacity="0.5"
                  spinner-variant="primary"
                >
                  <taxonomy-list-item
                    :key="'keyword-three-' + index"
                    :keyword="keyword"
                    :selectedKeyword="selectedKeywordThree"
                    :editing="editingThree"
                    @set="setKeywordThree($event)"
                    @startEditing="startEditing($event, 3)"
                    @save="saveKeyword(keyword, $event, 3)"
                    @deactivate="deactivateKeyword($event)"
                    @reactivate="reactivateKeyword($event)"
                    @delete="deleteKeyword($event, 3)"
                  ></taxonomy-list-item>
                </b-overlay>
              </template>
            </b-list-group>
          </b-col>
          <b-col cols="3">
            <div v-if="keywordsFour.length === 0" class="bg-light h-100 rounded"></div>
            <b-list-group>
              <template v-for="(keyword, index) of keywordsFour">
                <b-overlay
                  :show="loadingItemId === keyword.id"
                  :key="'keyword-four-spinner' + index"
                  variant="light"
                  :opacity="0.5"
                  spinner-variant="primary"
                >
                  <taxonomy-list-item
                    :key="'keyword-four-' + index"
                    :keyword="keyword"
                    :selectedKeyword="selectedKeywordFour"
                    :editing="editingFour"
                    @set="setKeywordFour($event)"
                    @startEditing="startEditing($event, 4)"
                    @save="saveKeyword(keyword, $event, 4)"
                    @deactivate="deactivateKeyword($event)"
                    @reactivate="reactivateKeyword($event)"
                    @delete="deleteKeyword($event, 4)"
                  ></taxonomy-list-item>
                </b-overlay>
              </template>
            </b-list-group>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  import Treeview from '@/components/Treeview.vue'
  import TaxonomyListItem from '../../components/admin/components/TaxonomyListItem.vue'
  export default {
    name: 'Keywords',
    components: { Treeview, TaxonomyListItem },
    data: () => ({
      tab: 'Trævisning',
      selectedKeywordOne: null,
      selectedKeywordTwo: null,
      selectedKeywordThree: null,
      selectedKeywordFour: null,
      keywordOneInput: '',
      keywordTwoInput: '',
      keywordThreeInput: '',
      keywordFourInput: '',
      keywordOneSaving: false,
      keywordTwoSaving: false,
      keywordThreeSaving: false,
      keywordFourSaving: false,
      myCustomOptions: {
        icon: "fa-folder",
        iconColor: "#007AD5",
        selectedIcon: "fa-folder-open",
        selectedIconColor: "#2ECC71",
        addElemIcon: 'fa-plus',
        addElemIconColor: '#007AD5',
        style: {
          tree: 'overflow: hidden; border: none;',
          row: 'background-color: blue;'
        },
      },
      taxonomy: null,
      loading: true,
      loadingItemId: null,
      activeTab: 'treeview',
      editingOne: false,
      editingTwo: false,
      editingThree: false,
      editingFour: false,
      copy: '',
      modalSettings: {
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'secondary',
        okTitle: 'Ja',
        cancelTitle: 'Nej',
        cancelVariant: 'primary',
        centered: true
      }
    }),
    watch: {
      activeTab: function () {
        if (this.activeTab !== 'treeview') {
          this.$router.push({ query: { tab: this.activeTab }}).catch(() => {})
        } else {
          this.$router.push({ query: {}}).catch(() => {})
        }
      }
    },
    mounted() {
      this.$route.params.tab ? this.activeTab = this.$route.params.tab : null
      if (this.$route.query && this.$route.query.tab) {
        this.activeTab = this.$route.query.tab
      }
      this.getTaxonomy()
    },
    computed: {
      sortedTaxonomy() {
        if (this.taxonomy) {
          return this.taxonomy.slice().sort(function(a, b){
            return (a.value > b.value) ? 1 : -1
          })
        }
        return []
      },
      keywordsTwo() {
        if (this.selectedKeywordOne) {
          let keyword = this.taxonomy.find(keyword => keyword.key === this.selectedKeywordOne)
          if (keyword.children) {
            return keyword.children.sort(function(a, b){
              return (a.value > b.value) ? 1 : -1
            })
          } else {
            return []
          }
        }
        return []
      },
      keywordsThree() {
        if (this.selectedKeywordTwo) {
          let keyword = this.keywordsTwo.find(keyword => keyword.key === this.selectedKeywordTwo)
          if (keyword.children) {
            return keyword.children.sort(function(a, b){
              return (a.value > b.value) ? 1 : -1
            })
          } else {
            return []
          }
        }
        return []
      },
      keywordsFour() {
        if (this.selectedKeywordThree) {
          let keyword = this.keywordsThree.find(keyword => keyword.key === this.selectedKeywordThree)
          if (keyword.children) {
            return keyword.children.sort(function(a, b){
              return (a.value > b.value) ? 1 : -1
            })
          } else {
            return []
          }
        }
        return []
      }
    },
    methods: {
      getTaxonomy () {
        this.axios.get('/api/taxonomy').then((response) => {
          this.loading = false
          let data = response.data
          //console.log(data)
          this.taxonomy = data
          this.stopEditing()
          this.loadingItemId = null
        })
      },
      startEditing(value, num) {
        this.copy = value
        this.stopEditing()
        switch(num) {
          case 1:
            this.editingOne = true
            break;
          case 2:
            this.editingTwo = true
            break;
          case 3:
            this.editingThree = true
            break;
          case 4:
            this.editingFour = true
            break;
          default:
            this.editingOne = true
        }
      },
      stopEditing(num = null) {
        switch(num) {
          case 1:
            this.editingOne = false
            break;
          case 2:
            this.editingTwo = false
            break;
          case 3:
            this.editingThree = false
            break;
          case 4:
            this.editingFour = false
            break;
          default:
            this.editingOne = false
            this.editingTwo = false
            this.editingThree = false
            this.editingFour = false
        }
      },
      saveKeyword(keyword, newValue, num) {
        let editedKeyword = {
          id: keyword.id,
          key: keyword.key,
          value: newValue,
          level: num
        }
        this.loadingItemId = keyword.id
        let config = this.$store.getters.getConfig
        this.axios.put('/api/taxonomy/' + keyword.id + '/', editedKeyword, config).then((response) => {
          keyword.value = response.data.value
          this.stopEditing(num)
          this.loadingItemId = null
        }).catch((error) => {
          console.log(error)
          this.stopEditing(num)
          this.loadingItemId = null
        })
      },
      deactivateKeyword(keyword) {
        this.$bvModal.msgBoxConfirm(
          'Vil du deaktivere dette taksonomibegreb?',
          this.modalSettings
        ).then((response) => {
          if (response) {
            this.loadingItemId = keyword.id
            let config = this.$store.getters.getConfig
            this.axios.patch('/api/taxonomy/' + keyword.id + '/', {active: false}, config).then(() => {
              keyword.active = false
              this.loadingItemId = null
              this.stopEditing()
            }).catch((error) => {
              console.log(error)
              this.loadingItemId = null
              this.stopEditing()
            })
          }
        })
      },
      reactivateKeyword(keyword) {
        this.$bvModal.msgBoxConfirm(
          'Vil du genaktivere dette taksonomibegreb?',
          this.modalSettings
        ).then((response) => {
          if (response) {
            this.loadingItemId = keyword.id
            let config = this.$store.getters.getConfig
            this.axios.patch('/api/taxonomy/' + keyword.id + '/', {active: true}, config).then(() => {
              keyword.active = true
              this.loadingItemId = null
              this.stopEditing()
            }).catch((error) => {
              console.log(error)
              this.loadingItemId = null
              this.stopEditing()
            })
          }
        })
      },
      deleteKeyword(keyword, num) {
        this.$bvModal.msgBoxConfirm(
          'Vil du slette dette taksonomibegreb?',
          this.modalSettings
        ).then((response) => {
          if (response) {
            this.loadingItemId = keyword.id
            let config = this.$store.getters.getConfig
            this.axios.delete('/api/taxonomy/' + keyword.id + '/', config).then(() => {
              if (num === 1) {
                this.selectedKeywordOne = null
                this.selectedKeywordTwo = null
                this.selectedKeywordThree = null
                this.selectedKeywordFour = null
              } else if (num === 2) {
                this.selectedKeywordTwo = null
                this.selectedKeywordThree = null
                this.selectedKeywordFour = null
              } else if (num === 3) {
                this.selectedKeywordThree = null
                this.selectedKeywordFour = null
              } else if (num === 4) {
                this.selectedKeywordFour = null
              }
              this.getTaxonomy()
            }).catch((error) => {
              console.log(error)
              this.loadingItemId = null
              this.stopEditing()
            })
          }
        })
      },
      setKeywordOne(key) {
        this.stopEditing()
        if (this.selectedKeywordOne !== key) {
          this.selectedKeywordOne = key
          this.resetKeywords(true, true, true)
        }
      },
      addKeywordOne() {
        if (this.keywordOneInput !== '') {
          this.keywordOneSaving = true
          let keywordObj = {
            value: this.keywordOneInput,
            key: this.keywordOneInput.toLowerCase(),
            parent: null,
            level: 1
          }
          let config = this.$store.getters.getConfig
          this.axios.post('/api/taxonomy/', keywordObj, config).then((response) => {
            this.keywordOneSaving = false
            let newKeyword = response.data
            newKeyword.children = []
            this.taxonomy.push(newKeyword)
            this.setKeywordOne(newKeyword.key)
            this.keywordOneInput = ''
          }).catch((error) => {
            this.keywordOneSaving = false
            console.log(error)
          })
        }
      },
      setKeywordTwo(key) {
        this.stopEditing()
        if (this.selectedKeywordTwo !== key) {
          this.selectedKeywordTwo = key
          this.resetKeywords(false, true, true)
        }
      },
      addKeywordTwo() {
        if (this.keywordTwoInput !== '') {
          this.keywordTwoSaving = true
          const keyword1 = this.taxonomy.find(keyword => keyword.key === this.selectedKeywordOne)
          let keywordObj = {
            value: this.keywordTwoInput,
            key: this.keywordTwoInput.toLowerCase(),
            parent: keyword1.id,
            level: 2
          }
          let config = this.$store.getters.getConfig
          this.axios.post('/api/taxonomy/', keywordObj, config).then((response) => {
            this.keywordTwoSaving = false
            let newKeyword = response.data
            newKeyword.children = []
            keyword1.children.push(newKeyword)
            this.setKeywordTwo(newKeyword.key)
            this.keywordTwoInput = ''
          }).catch((error) => {
            this.keywordTwoSaving = false
            console.log(error)
          })
        }
      },
      setKeywordThree(key) {
        this.stopEditing()
        if (this.selectedKeywordThree !== key) {
          this.selectedKeywordThree = key
          this.resetKeywords(false, false, true)
        }
      },
      addKeywordThree() {
        if (this.keywordThreeInput !== '') {
          this.keywordThreeSaving = true
          const keyword1 = this.taxonomy.find(keyword => keyword.key === this.selectedKeywordOne)
          const keyword2 = keyword1.children.find(keyword => keyword.key === this.selectedKeywordTwo)
          let keywordObj = {
            value: this.keywordThreeInput,
            key: this.keywordThreeInput.toLowerCase(),
            parent: keyword2.id,
            level: 3
          }
          let config = this.$store.getters.getConfig
          this.axios.post('/api/taxonomy/', keywordObj, config).then((response) => {
            this.keywordThreeSaving = false
            let newKeyword = response.data
            newKeyword.children = []
            keyword2.children.push(newKeyword)
            this.setKeywordThree(newKeyword.key)
            this.keywordThreeInput = ''
          }).catch((error) => {
            this.keywordThreeSaving = false
            console.log(error)
          })
        }
      },
      setKeywordFour(key) {
        this.stopEditing()
        if (this.selectedKeywordFour !== key) {
          this.selectedKeywordFour = key
        }
      },
      addKeywordFour() {
        if (this.keywordFourInput !== '') {
          this.keywordFourSaving = true
          const keyword1 = this.taxonomy.find(keyword => keyword.key === this.selectedKeywordOne)
          const keyword2 = keyword1.children.find(keyword => keyword.key === this.selectedKeywordTwo)
          const keyword3 = keyword2.children.find(keyword => keyword.key === this.selectedKeywordThree)
          let keywordObj = {
            value: this.keywordFourInput,
            key: this.keywordFourInput.toLowerCase(),
            parent: keyword3.id,
            level: 4
          }
          let config = this.$store.getters.getConfig
          this.axios.post('/api/taxonomy/', keywordObj, config).then((response) => {
            this.keywordFourSaving = false
            let newKeyword = response.data
            keyword3.children.push(newKeyword)
            this.setKeywordFour(newKeyword.key)
            this.keywordFourInput = ''
          }).catch((error) => {
            this.keywordFourSaving = false
            console.log(error)
          })
        }
      },
      resetKeywords(key2 = false, key3 = false, key4 = false) {
        if (key2) {
          this.selectedKeywordTwo = null
        }
        if (key3) {
          this.selectedKeywordThree = null
        }
        if (key4) {
          this.selectedKeywordFour = null
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .keyword {
    span.keyword-text {
      word-break: break-word;
      hyphens: auto;
    }
    &.active {
      position: relative;
    }
  }

  .deactivated {
    opacity: .5;
  }
</style>